module.exports = __webpack_public_path__ + "static/eats-everything-c6d41d436f36f3c190110c74bbb139ff.png";